import { render, staticRenderFns } from "./my.vue?vue&type=template&id=b28e13ee&scoped=true&"
import script from "./my.vue?vue&type=script&lang=ts&"
export * from "./my.vue?vue&type=script&lang=ts&"
import style0 from "./my.vue?vue&type=style&index=0&id=b28e13ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28e13ee",
  null
  
)

export default component.exports